import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ResponsiveService } from '@frk/eds-components';
import { CartHandlerService } from '@literature/services/cart-handler.service';
import { LiteratureGlobalConfigService } from '@literature/services/literature-global-config.service';
import { LiteratureDocumentListingState } from '@types';
import { Observable } from 'rxjs';

@Component({
  selector: 'ft-my-cart-summary',
  templateUrl: './my-cart-summary.component.html',
})
export class MyCartSummaryComponent implements OnInit {
  isHandheld$: Observable<boolean>;
  isMobile$: Observable<boolean>;
  cartState$: Observable<LiteratureDocumentListingState>;
  myCartLink: string;

  constructor(
    private responsiveService: ResponsiveService,
    private cartHandlerService: CartHandlerService,
    private changeDetectionRef: ChangeDetectorRef,
    private literatureConfig: LiteratureGlobalConfigService
  ) {
    this.isHandheld$ = this.responsiveService.isHandheld$();
    this.isMobile$ = this.responsiveService.isMobile$();
  }

  ngOnInit(): void {
    this.cartState$ = this.cartHandlerService.getCartItems();
    this.myCartLink = this.literatureConfig?.navigationUrls?.litOrderCheckoutUrl;
    this.changeDetectionRef.detectChanges();
  }
  /**
   * get literature details page link
   * @param url string
   * @returns string
   */
  getLiteratureDetailLink(docId: string): string {
    return `${this.literatureConfig?.navigationUrls?.litDetailUrl}/${docId}`;
  }
}
